const Datastore = require('nedb')

class Users {
    db = new Datastore({ filename: "./users.db", autoload: true });

    constructor() {
        this.db.ensureIndex({fieldName: "userName", unique: true})
        this.db.ensureIndex({fieldName: "pin", unique: true})
        // this.db.find({userName: "admin0"},(err, data) => {
        //     console.log(this.db.getAllData())
        // })
        // for(var i=0; i<200 ; i++)
        //     this.db.remove({userName: "admin" + i})
        // this.db.remove({userName: "mreina"})
        // this.db.remove({validated: true})
        // this.db.remove({userName: "user1"})
    }

    insert = (user, callback) => {
        this.db.insert(user, callback)
    }

    find = (criteria, callback) => {
        this.db.find(criteria, callback);
    }

    findOne = (criteria, callback) => {
        this.db.findOne(criteria, callback);
    }

    insert = (user, callback) => {
        this.db.insert(user, callback);
    }

    remove = (criteria, callback) => {
        this.db.remove(criteria, callback);
    }

    getValidation = (callback) => {
        this.db.findOne({validated: true}, callback);
    }

    update = (criteria, values, callback) => {
        this.db.update(criteria, values, callback);
    }
}

let users = new Users()

export default users;


// WEBPACK FOOTER //
// ./src/services/users/index.js